module.exports = __webpack_public_path__ + "static/fabric-bw-min-facf613bd7b05c61f188e9f3a037b934.jpg";